<script setup lang="ts">
import { defineProps } from "vue";
import { HourGeneralInfo } from "@/types/calculators";

defineProps<{
  general: HourGeneralInfo;
}>();
</script>

<template>
  <div class="flex flex-wrap gap-1 items-center">
    <span
      v-if="general.elite_markers.is_gui_deng_tian_men"
      class="px-2 py-0.5 rounded text-[10px] font-bold bg-gold text-white"
    >
      ★ 贵登天门
    </span>
    <span
      v-if="general.elite_markers.is_si_da_ji_shi"
      class="px-2 py-0.5 rounded text-[10px] font-bold bg-[#FFF9EE] text-[#9A6E1E] border border-gold/30"
    >
      四大吉时 ({{ general.elite_markers.si_da_ji_shi.symbol_8gan_4wei }})
    </span>
    <span
      v-for="auspGod in general.shen_sha.auspicious_gods"
      :key="auspGod.code"
      class="px-1.5 py-0.5 rounded text-[10px] bg-secondary text-brown"
    >
      {{ auspGod.name.split(" ")[0] }}
    </span>
    <span
      v-for="evilGod in general.shen_sha.evil_gods"
      :key="evilGod.code"
      class="px-1.5 py-0.5 rounded text-[10px] bg-error/10 text-error"
    >
      {{ evilGod.name.split(" ")[0] }}
    </span>
  </div>
</template>
